import { HeaderTwoColumnLayoutSkeleton } from 'layouts';

const VideoDetailSkeleton = () => (
  <HeaderTwoColumnLayoutSkeleton
    header={{ paragraph: { rows: 6 } }}
    left={[{ paragraph: { rows: 2 } }, { paragraph: { rows: 6 } }]}
    right={[{ paragraph: { rows: 2 } }]}
  />
);

export default VideoDetailSkeleton;
